import {
  useNavigate,
  createSearchParams,
  useSearchParams,
} from 'react-router-dom';
import { useCallback, useEffect } from 'react';

import { LoginPageBase } from './LoginPageBase';
import { DefaultLoginForm } from './widgets/DefaultLoginForm';
import { removeLocalStorage } from 'fiutil/storage';

import './login.less';

export function LoginPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const next = params.get('next')?.trim();
  const onLoginSuccess = useCallback(() => {
    navigate('/postlogin' + (next ? `?${createSearchParams({ next })}` : ''));
  }, [navigate]);

  // remove justLogin flag if it exists
  useEffect(() => {
    removeLocalStorage('justLogin');
  }, []);

  const renderLoginForm = useCallback(
    ({ loginEnv }) => {
      return (
        <DefaultLoginForm onLoginSuccess={onLoginSuccess} loginEnv={loginEnv} />
      );
    },
    [onLoginSuccess]
  );

  return <LoginPageBase renderLoginForm={renderLoginForm} />;
}
